<swiper-container
  #swiper
  [initial-slide]="swiperIndex"
  [disabled]="media.length < 2"
>
  @for (item of media; track trackBy($index, item)) {
    <swiper-slide>
      <ca-image-download-button
        [url]="item | mediaPreview | filedownloadurl | async"
        [memoID]="memoId"
        [fileID]="item.id"
      >
        @if (!(item | mediaIsVideo)) {
          <ca-image-loader
            [background]="false"
            fit="contain"
            [image]="item | filedownloadurl | async"
            [blur]="item | mediaVariant | mediaBlurUrl"
            [showPlaceholder]="true"
          ></ca-image-loader>
        }
      </ca-image-download-button>
      @if (item | mediaIsVideo) {
        <div class="video-container">
          @if (item | mediaPreview) {
            <video
              [poster]="item | mediaPreview | filedownloadurl | async"
              controls
            >
              @for (variant of supportedVideoVariants; track variant) {
                @if (
                  item
                    | mediaVariant: "purpose" : variant
                    | filedownloadurl
                    | async;
                  as mediaSource
                ) {
                  @if (item | mediaVariant: "purpose" : variant) {
                    <source
                      [src]="mediaSource"
                      [type]="(item | mediaVariant: 'purpose' : variant).mimeType"
                    />
                  }
                }
              }
            </video>
          } @else {
            <div class="video-preparing">
              <strong>Video Processing...</strong><br />
              Your video will be ready soon - please check back later.
            </div>
          }
        </div>
      }
    </swiper-slide>
  }
</swiper-container>

@if (media.length > 1) {
  <ca-swiper-pagination
    (changeIndex)="changeSlideTo($event)"
    [items]="media"
    [activeIndex]="swiperIndex"
  ></ca-swiper-pagination>
}
